import { render, staticRenderFns } from "./SettingsLang.vue?vue&type=template&id=5a60100e&"
import script from "./SettingsLang.vue?vue&type=script&lang=js&"
export * from "./SettingsLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports